//model-meta generated file
import {DateTime,ModelMeta,uuid} from '../../lib/model-meta';
import {WhereTable,RestTypes as _RestTypes} from '../../lib/model-meta';

export class DataInterval{
	public id:number;
	public deviceId:number;
	public localId:number;
	public begin:number;
	public end:number;
	public blastSiteId:number|null=null;
	public machineId:number|null=null;
	public score:number=1;
	public iqaScore:number=1;
	public isDeleted:boolean=false;
	public muckpileId:number|null=null;
	public vehicleId:number|null=null;
	public isCountedInToleranceAlert:boolean=false;
	public isCountedInOffSpecAlert:boolean=false;
	public objectType:number=0;
}

export namespace DataInterval{
	export const meta=new ModelMeta<keyof Props>(
		"DataInterval",
		[],
		[
			{
				name: "id",
				type: "serial",
				decorators: {},
				uniqueKey: true,
				notNull: true
			},{
				name: "deviceId",
				type: "int",
				decorators: {
					index: true
				},
				index: true,
				notNull: true
			},{
				name: "localId",
				type: "int",
				decorators: {},
				notNull: true
			},{
				name: "begin",
				type: "int",
				decorators: {
					index: true
				},
				index: true,
				notNull: true
			},{
				name: "end",
				type: "int",
				decorators: {},
				notNull: true
			},{
				name: "blastSiteId",
				type: "int",
				decorators: {},
				default: null,
				optional: true
			},{
				name: "machineId",
				type: "int",
				decorators: {},
				default: null,
				optional: true
			},{
				name: "score",
				type: "number",
				decorators: {},
				default: 1,
				optional: true,
				notNull: true
			},{
				name: "iqaScore",
				type: "number",
				decorators: {},
				default: 1,
				optional: true,
				notNull: true
			},{
				name: "isDeleted",
				type: "boolean",
				decorators: {},
				default: false,
				optional: true,
				notNull: true
			},{
				name: "muckpileId",
				type: "int",
				decorators: {},
				default: null,
				optional: true
			},{
				name: "vehicleId",
				type: "int",
				decorators: {},
				default: null,
				optional: true
			},{
				name: "isCountedInToleranceAlert",
				type: "boolean",
				decorators: {},
				default: false,
				optional: true,
				notNull: true
			},{
				name: "isCountedInOffSpecAlert",
				type: "boolean",
				decorators: {},
				default: false,
				optional: true,
				notNull: true
			},{
				name: "objectType",
				type: "int",
				decorators: {},
				default: 0,
				optional: true,
				notNull: true
			}
		]
	);

	interface Props{
		id:number;
		deviceId:number;
		localId:number;
		begin:number;
		end:number;
		blastSiteId?:number|null;
		machineId?:number|null;
		score?:number;
		iqaScore?:number;
		isDeleted?:boolean;
		muckpileId?:number|null;
		vehicleId?:number|null;
		isCountedInToleranceAlert?:boolean;
		isCountedInOffSpecAlert?:boolean;
		objectType?:number;
	}


	meta.generateRest("data-interval",[
		{
			name: "email",
			type: "string",
			decorators: {}
		},{
			name: "authToken",
			type: "string",
			decorators: {}
		}
	]);

	export interface ReadableProps{
		id:number;
		deviceId:number;
		localId:number;
		begin:number;
		end:number;
		blastSiteId?:number|null;
		machineId?:number|null;
		score?:number;
		iqaScore?:number;
		isDeleted?:boolean;
		muckpileId?:number|null;
		vehicleId?:number|null;
		isCountedInToleranceAlert?:boolean;
		isCountedInOffSpecAlert?:boolean;
		objectType?:number;
	}

	export interface ReadablePrimitiveProps{
		id:number;
		deviceId:number;
		localId:number;
		begin:number;
		end:number;
		blastSiteId?:number|null;
		machineId?:number|null;
		score?:number;
		iqaScore?:number;
		isDeleted?:boolean;
		muckpileId?:number|null;
		vehicleId?:number|null;
		isCountedInToleranceAlert?:boolean;
		isCountedInOffSpecAlert?:boolean;
		objectType?:number;
	}

	namespace body{

		interface WritableProps{
			deviceId:number;
			localId:number;
			begin:number;
			end:number;
			blastSiteId?:number|null;
			machineId?:number|null;
			score?:number;
			iqaScore?:number;
			isDeleted?:boolean;
			muckpileId?:number|null;
			vehicleId?:number|null;
			isCountedInToleranceAlert?:boolean;
			isCountedInOffSpecAlert?:boolean;
			objectType?:number;
		}

		export interface Auth{
			email?:string;
			authToken?:string;
		}

		export interface Get extends Auth{
			where:number;
			fields?:(keyof ReadableProps)[];
		}

		export interface Put extends Auth{
			where:number;
			fields:Partial<WritableProps>;
		}

		export interface Post extends Auth{
			fields:Partial<WritableProps>;
		}

		export interface Delete extends Auth{
			where:number;
		}

		export interface Count extends Auth{
			where?:WhereTable<keyof ReadablePrimitiveProps>;
		}

		export interface Search extends Auth{
			fields?:(keyof ReadablePrimitiveProps)[];
			where?:WhereTable<keyof ReadablePrimitiveProps>;
			range?:[number,number];
			sort?:Partial<Record<keyof ReadablePrimitiveProps,'+'|'-'>>;
		}
	}

	namespace _response{
		export type Get=Partial<ReadableProps>;
		export type Search=Partial<ReadablePrimitiveProps>[];
	}

	export interface RestTypes extends _RestTypes{
		body:{
			Auth:body.Auth;
			Get:body.Get;
			Put:body.Put;
			Post:body.Post;
			Delete:body.Delete;
			Count:body.Count;
			Search:body.Search;
		}

		response: {
			Get:_response.Get;
			Search:_response.Search;
		}
	}

}
